import React from "react";
import MovieContainer from "./MovieContainer";
import MovieItem from "./MovieItem";
import PropTypes from "prop-types";
export const convertDate = (date) => {
  if (typeof date === "string") {
    let altered = date.split("-").map((el) => parseInt(el, 10));
    let months = [
      "",
      "Jan",
      "Feb",
      "Mar",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return String(`${months[altered[1]]} ${[altered[2]]} ${[altered[0]]}`);
  }
};
export default function Movies({ movies }) {
  return (
    <div>
      <MovieContainer>
        {movies.map((movie) => {
          return (
            <MovieItem
              key={movie.id}
              rating={movie.vote_average * 10}
              releaseDate={convertDate(movie.release_date)}
              movieId={movie.id}
              title={movie.original_title}
              img={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`}
              url={`/${movie.id}`}
            />
          );
        })}
      </MovieContainer>
    </div>
  );
}
Movies.propTypes = {
  movies: PropTypes.array.isRequired,
};
